import { render, staticRenderFns } from "./VPChart.vue?vue&type=template&id=0dd05f08"
import script from "./VPChart.vue?vue&type=script&lang=ts"
export * from "./VPChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports